<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="850"
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <!--begin::Modal header-->
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">{{ headerText }}</h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--end::Modal header-->
      <!--begin::Modal body-->
      <div class="modal-body d-flex flex-column scroll-y mx-5 py-7">
        <div class="row flex-grow-0 flex-shrink-0 py-7">
          <div class="col-12 col-md-6 h-75px">
            <v-text-field
              v-model="formData.name"
              :label="$t('name')"
              clearable
              outlined
              dense
              :error-messages="nameErrors"
              @blur="$v.formData.name.$touch()"
            />
          </div>

          <div class="col-12 col-md-6 h-75px">
            <v-file-input
              dense
              outlined
              v-model="formData.icon"
              :label="$t('icon')"
              clearable
              prepend-icon="mdi-svg"
              :error-messages="iconErrors"
              @blur="$v.formData.icon.$touch()"
            />
            <!--              :prepend-icon="formData.icon ?? 'mdi-svg'"-->
          </div>

          <div class="col-12 col-md-6 h-75px">
            <v-text-field
              v-model.number="formData.monthly_price"
              :label="$t('monthly_price')"
              clearable
              outlined
              dense
              type="number"
              :min="0"
              @change="() => validateMinValue('monthly_price', 0)"
              :error-messages="monthly_priceErrors"
              @blur="$v.formData.monthly_price.$touch()"
            />
          </div>

          <div class="col-12 col-md-6 h-75px">
            <v-text-field
              v-model.number="formData.yearly_price"
              :label="$t('yearly_price')"
              clearable
              outlined
              dense
              type="number"
              :min="formData.monthly_price"
              @change="
                () => validateMinValue('yearly_price', formData.monthly_price)
              "
              :error-messages="yearly_priceErrors"
              @blur="$v.formData.yearly_price.$touch()"
            />
          </div>

          <div class="col-12 col-md-6 h-75px">
            <v-text-field
              v-model.number="formData.discounted_monthly_price"
              :label="$t('discounted_monthly_price')"
              clearable
              outlined
              dense
              type="number"
              :min="0"
              @change="() => validateMinValue('monthly_price', 0)"
            />
          </div>

          <div class="col-12 col-md-6 h-75px">
            <v-text-field
              v-model.number="formData.discounted_yearly_price"
              :label="$t('discounted_yearly_price')"
              clearable
              outlined
              dense
              type="number"
              :min="formData.monthly_price"
              @change="
                () => validateMinValue('yearly_price', formData.monthly_price)
              "
            />
          </div>

          <div class="col-12 d-flex flex-row align-center h-75px px-5">
            <p
              class="mb-0 poppins font-weight-medium"
              style="
                color: rgba(0, 0, 0, 0.6) !important;
                font-size: 16px !important;
              "
            >
              Default subscription?
            </p>
            <!--            <v-switch-->
            <!--              class="my-0 py-0 mx-4"-->
            <!--              v-model="formData.is_default"-->
            <!--              inset-->
            <!--              dense-->
            <!--              :true-value="1"-->
            <!--              :false-value="0"-->
            <!--            />-->
            <v-radio-group
              class="my-0 py-0 mx-6"
              v-model="formData.is_default"
              row
              hide-details
              style="font-size: 16px !important"
            >
              <v-radio :label="$t('no')" :value="false" />
              <v-radio :label="$t('yes')" :value="true" />
            </v-radio-group>
          </div>

          <div class="col-12">
            <FeatureTable :items="features" :setItems="addFeature" />
            <!--            <Multiselect-->
            <!--              v-model="formData.features"-->
            <!--              class="multi-select-filter-sidebar"-->
            <!--              tag-placeholder="Add this"-->
            <!--              placeholder="Feature"-->
            <!--              :options="featureOptions"-->
            <!--              label="name"-->
            <!--              track-by="code"-->
            <!--              openDirection="bottom"-->
            <!--              :multiple="true"-->
            <!--              :taggable="true"-->
            <!--              ref="selectRef"-->
            <!--              @tag="(query) => addTag(query)"-->
            <!--            >-->
            <!--              <template #clear>-->
            <!--                <div-->
            <!--                  class="multiselect__clear"-->
            <!--                  v-if="formData.features.length"-->
            <!--                  @click.prevent.stop="resetReceivers"-->
            <!--                ></div>-->
            <!--              </template>-->
            <!--            </Multiselect>-->
          </div>
        </div>

        <!--begin::Actions-->
        <div
          class="my-4 min-h-75px d-flex flex-grow-1 align-end justify-center"
        >
          <button
            type="reset"
            class="btn btn-light mr-3 px-5 py-3 ls1"
            @click="resetFormData"
          >
            Clear
          </button>
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submitForm"
          >
            {{ submitButtonText }}
          </button>
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import swalEdited from "@/core/services/AlertServices/SwalEdited";
import swalAdded from "@/core/services/AlertServices/SwalAdded";
// import Multiselect from "vue-multiselect";
import fieldValueValidation from "@/own/mixins/fieldValueValidation.js";
import FeatureTable from "@/own/components/orderManagement/subscriptionPlans/featureTable/FeatureTable.vue";

export default {
  name: "ActionsDialog",
  components: { FeatureTable },
  // components: { Multiselect },
  props: ["refresher", "pageLoader"],
  mixins: [validationMixin, fieldValueValidation],
  validations: {
    formData: {
      name: { required },
      monthly_price: { required },
      yearly_price: { required },
      icon: { required },
    },
  },
  data: () => ({
    dialog: false,
    formData: {
      name: null,
      monthly_price: null,
      yearly_price: null,
      discounted_monthly_price: null,
      discounted_yearly_price: null,
      is_default: false,
      icon: null,
    },
    features: [],
    featureOptions: [],
  }),
  methods: {
    addFeature(items) {
      this.features = [...items];
      // this.features.push({
      //   feature: item,
      //   index: this.features.length + 1,
      // });
    },
    addTag(newTag) {
      newTag
        .trim()
        .replace(/,\s*/g, " ")
        .replace(/\s\s+/g, " ")
        .split(" ")
        .forEach((element) => {
          this.featureOptions.push({
            name: element,
            code:
              element.substring(0, 2) + Math.floor(Math.random() * 10000000),
          });
          this.features.push({
            name: element,
            code:
              element.substring(0, 2) + Math.floor(Math.random() * 10000000),
          });
        });

      setTimeout(() => {
        this.$refs.selectRef.$el.focus();
      }, 100);
    },
    resetReceivers() {
      this.featureOptions = [];
      this.features = [];
    },
    async loadDataFromServer() {
      this.pageLoader(true);
      this.resetReceivers();
      const payload = {};
      let actionUrl = "create";
      if (this.actionType) {
        actionUrl = "edit";
        payload.id = this.$store.getters.getItemForAction.id;
      }
      await ApiService.post(
        `/order_management/subscription_plans/${actionUrl}`,
        payload
      )
        .then((response) => {
          const { data } = response;
          if (this.actionType) {
            this.formData = data.subscription_plan;
            data?.subscription_plan?.features.forEach((element, index) => {
              this.features.push({
                feature: element,
                index: index + 1,
              });
              // console.log("this.features", this.features);

              // this.featureOptions.push({
              //   name: element,
              //   code:
              //     element.substring(0, 2) +
              //     Math.floor(Math.random() * 10000000),
              // });
              // this.features.push({
              //   name: element,
              //   code:
              //     element.substring(0, 2) +
              //     Math.floor(Math.random() * 10000000),
              // });
            });
          }
        })
        .catch(() => {
          // this.dialog = false;
          this.pageLoader(false);
        })
        .finally(() => {
          this.pageLoader(false);
        });
    },
    toggleModal() {
      if (this.dialog) {
        this.resetFormData();
      } else {
        this.loadDataFromServer();
      }
      this.dialog = !this.dialog;
    },
    submitForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.pageLoader(true);
      let data = new FormData();
      let actionUrl = "store";

      if (this.actionType) {
        actionUrl = "update";
        data.append("id", this.$store.getters.getItemForAction.id);
      }

      data.append("name", this.formData.name);
      data.append("icon", this.formData.icon);
      data.append("monthly_price", this.formData.monthly_price);
      data.append("yearly_price", this.formData.yearly_price);

      data.append(
        "discounted_monthly_price",
        this.formData.discounted_monthly_price
      );

      data.append(
        "discounted_yearly_price",
        this.formData.discounted_yearly_price
      );

      data.append("is_default", this.formData.is_default);

      this.features.forEach((item) => {
        // data.append(`features[]`, item.name);
        data.append(`features[]`, item.feature);
      });

      ApiService.post(`/order_management/subscription_plans/${actionUrl}`, data)
        .then(() => {
          if (this.actionType) swalEdited();
          else swalAdded();
          this.toggleModal();
          this.refresher();
          this.dialog = false;
          this.resetFormData();
        })
        .finally(() => {
          this.pageLoader(false);
        });
    },
    resetFormData() {
      this.$v.$reset();
      this.formData = {
        name: null,
        yearly_price: null,
        monthly_price: null,
        discounted_monthly_price: null,
        discounted_yearly_price: null,
        is_default: false,
        icon: false,
        features: [],
      };
    },
    handleFormValidation(fieldName, vueObj) {
      const errors = [];
      if (!vueObj.$v.formData[fieldName].$dirty) return errors;
      if ("required" in vueObj.$v.formData[fieldName]) {
        !vueObj.$v.formData[fieldName].required &&
          errors.push(this.$t("validation_this_field_is_required"));
      }
      return errors;
    },
  },
  computed: {
    //if true, we are editing item, false we are adding
    actionType: function () {
      return !!this.$store.getters.getItemForAction;
    },
    submitButtonText: function () {
      if (this.actionType) return "Update";
      else return "Submit";
    },
    headerText: function () {
      if (this.actionType) return "Edit Item";
      else return "Add New Item";
    },
    nameErrors: function () {
      return this.handleFormValidation("name", this);
    },
    monthly_priceErrors: function () {
      return this.handleFormValidation("monthly_price", this);
    },
    yearly_priceErrors: function () {
      return this.handleFormValidation("yearly_price", this);
    },
    iconErrors: function () {
      return this.handleFormValidation("icon", this);
    },
  },
};
</script>
